import { TablePagination } from "@/components/Pagination/TablePagination"
import { ExchangeFilter } from "@/components/Transactions/Exchange/ExchangeFilter"
import { ExchangeList } from "@/components/Transactions/Exchange/List"
import { useIBANExTransactions } from "@usher/pe-client-front-end-lib"

const TYPE = "IBAN"
const PER_PAGE = 5

export const TransactionsExchangeTypeIBAN = () => {
  const { data, isLoading, isInitialized, onFilter, dataTotal, pageCount, pageIndex, setPageIndex } = useIBANExTransactions({
    type: TYPE,
    pageSize: PER_PAGE,
  })
  return (
    <>
      <ExchangeFilter onFilter={onFilter} type={TYPE} />
      <ExchangeList loading={isLoading} type={TYPE} orders={data} isInitialized={isInitialized} />
      <TablePagination dataTotal={dataTotal} currentPage={pageIndex} totalPages={pageCount} onPageChange={setPageIndex} />
    </>
  )
}
